import { Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { PackingUnit } from '../packing-units';
import { PackingUnitDto } from '../dto/packing-unit-dto';

export const mapPackingUnit = (locales: Locale[], packingUnit: PackingUnitDto): PackingUnit => ({
    id: packingUnit.id,
    minimumQuantity: packingUnit.minimumQuantity,
    maximumQuantity: packingUnit.maximumQuantity,
    unitName: getLocalizedString(locales, packingUnit.unitName),
});
